import { render, staticRenderFns } from "./ComissaoDadosMembrosNovo.vue?vue&type=template&id=3f9d4416"
import script from "./ComissaoDadosMembrosNovo.vue?vue&type=script&lang=js"
export * from "./ComissaoDadosMembrosNovo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports